





























import { Component, Prop } from 'vue-property-decorator';
import { CSSStyleOptions } from '../common-types';
import { SwExtendedVue } from '../sw-extended-vue';

const minimalFontSize = 12;

@Component
export default class SwIcon extends SwExtendedVue {
  @Prop(String)
  name: string;

  /** could be xxsmall, xsmall, small, medium, large, xlarge */
  @Prop({ type: [String, Number], default: 'medium' })
  size: string | number;

  @Prop({ type: String })
  color: string;

  @Prop({ type: Boolean, default: false })
  bottomAlign: boolean;

  @Prop({ type: Number, default: 0 })
  rotate: number;

  @Prop({ type: Boolean, default: false })
  asBlock: boolean;

  sizeMap: {[size: string]: number} = {
    xxsmall: 8,
    xsmall: 10,
    small: 14,
    medium: 18,
    xmedium: 20,
    large: 24,
    mlarge:29,
    xlarge: 36,
    xxlarge: 48,
  };

  get numericSize(): number {
    if (typeof this.size === 'number') {
      return this.size;
    }
    return this.sizeMap[this.size] || this.sizeMap['medium'];
  }

  get internalRotate(): string {
    return this.rotate !== undefined ? `rotate(${this.rotate}deg)` : '';
  }

  get styles(): CSSStyleOptions {
    return {
      width: `${this.numericSize}px`,
      height: `${this.numericSize}px`,
      transform: `${this.internalRotate}`,
      color: this.color || undefined,
    };
  }

  get innerStyles(): CSSStyleOptions {
    const effectiveFontSize = Math.max(minimalFontSize, this.numericSize);
    let scale = '';

    const style: CSSStyleOptions = {
      fontSize: `${effectiveFontSize}px`,
    };

    if (effectiveFontSize !== this.numericSize) {
      scale = `scale(${this.numericSize / effectiveFontSize})`;
      style.transform = scale;
      style.width = `${effectiveFontSize}px`;
      style.height = `${effectiveFontSize}px`;
      style.left = `${(this.numericSize - effectiveFontSize) / 2}px`;
      style.top = `${(this.numericSize - effectiveFontSize) / 2}px`;
    }

    return style;
  }
}
